export default function(unsafeFunction) {
  try {
    unsafeFunction();
  } catch (e) {
    console.error("Error caught by safelyExecute:", e);
  }
}



/** WEBPACK FOOTER **
 ** ./lib/safely_execute.js
 **/